import { render, staticRenderFns } from "./infos_list.vue?vue&type=template&id=35555c1f&scoped=true"
import script from "./infos_list.vue?vue&type=script&lang=js"
export * from "./infos_list.vue?vue&type=script&lang=js"
import style0 from "./infos_list.vue?vue&type=style&index=0&id=35555c1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35555c1f",
  null
  
)

export default component.exports